module.exports = __webpack_public_path__ + "static/img/327_TO8_2514.74247c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/327_TO8_2514.jpg
// module id = MTI4
// module chunks = 0